<template>
    <div>
        <group-element
                selectable
                movable
                resizable
                :connectable="!isReadOnly"
                :deletable="!isReadOnly"
                :id.sync="value.elementView.id"
                :x.sync="value.elementView.x"
                :y.sync="value.elementView.y"
                :label.sync="name"
                :width.sync="value.elementView.width"
                :height.sync="value.elementView.height"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:dblclick="openPanel"
                v-on:removeShape="onRemoveShape(value)"
                :_style="{stroke:'black',
                        'vertical-align': 'top',
                        'font-weight': 'bold',
                        'font-size': '16',}">
            
            <sub-controller
                    :image="'terminal.png'"
                    @click.prevent.stop="handleClick($event)"
            ></sub-controller>

            <sub-elements>
                <!--title-->
                <image-element
                        :image="imgSrc"
                        :sub-top="5"
                        :sub-left="5"
                        :sub-width="25"
                        :sub-height="25"
                ></image-element>
                <text-element
                        :sub-width="'100%'"
                        :sub-height="'180%'"
                        :sub-top="0"
                        :sub-left="0"
                        :text="'Workflow'">
                </text-element>
            </sub-elements>
        </group-element>

        <property-panel
                v-if="propertyPanel"
                v-model="value"
                :img="imgSrc"
                :readOnly="isReadOnly"
                @close="closePanel"
        >
        </property-panel>

        <vue-context-menu
            :elementId="value.elementView.id"
            :options="menuList"
            :ref="'vueSimpleContextMenu'"
            @option-clicked="optionClicked">
        </vue-context-menu>
    </div>
</template>

<script>
    import Element from "../KubernetesElement";
    import PropertyPanel from './WorkflowPanel'

    export default {
        mixins: [Element],
        name: 'workflow',
        components: {
            "property-panel": PropertyPanel
        },
        props: {},
        computed: {
            defaultStyle() {
                return {}
            },
            className() {
                return 'Workflow'
            },
            imgSrc() {
                return `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/argo/argo-icon-color.svg`
            },
            createNew(elementId, x, y, width, height, object) {
                return {
                    _type: this.className(),
                    name: '',
                    namespace: '',
                    elementView: {
                        '_type': this.className(),
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': width,
                        'height': height,
                        'style': JSON.stringify({}),
                        'angle': 0,
                    },
                    object: object ? object: {
                        "apiVersion": "argoproj.io/v1alpha1",
                        "kind": "Workflow",
                        "metadata": {
                            "generateName": ""
                        },
                        "spec": {
                            "entrypoint": "",
                            "templates": [
                                {
                                    "name": "",
                                    "steps": [
                                        []
                                    ],
                                    "dag": {
                                        "tasks": []
                                    }
                                }
                            ]
                        }
                    },
                    workflowType: null,
                    steps: [],
                    tasks: [],
                    advancedAttributePaths: {},
                }
            },
            name() {
                try {
                    return this.value.object.metadata.generateName;
                } catch(e) {
                    return "Untitled";
                }
            },
            namespace: {
                get: function() {
                    return this.value.object.metadata.namespace;
                },
                set: function (newVal){
                    this.value.object.metadata.namespace = newVal;
                }
            },
        },
        data: function () {
            return {
                stepComp: {
                    component: "workflowStep",
                    label: "step",
                    src: `${window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/argo/argo-icon-color.svg`,
                    x: 500 + Math.random()*200,
                    y: 280 + Math.random()*150
                },
                taskComp: {
                    component: "workflowDag",
                    label: "dag",
                    src: `${window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/argo/argo-icon-color.svg`,
                    x: 500 + Math.random()*200,
                    y: 280 + Math.random()*150
                }
            };
        },
        created() {
            var me = this;
            me.menuList.push({name: "argo submit"});
            me.menuList.push({name: "argo list"});
            me.menuList.push({name: "argo get " + me.value.object.metadata.generateName});
            me.menuList.push({name: "argo logs " + me.value.object.metadata.generateName});
        },
        mounted: function () {
            var me = this;
            if(me.value.workflowType == "steps") {
                me.setSteps((me.value.object.spec.templates[0].steps).length);
                delete me.value.object.spec.templates[0].dag;
            } else if(me.value.workflowType == "dag") {
                me.setTasks((me.value.object.spec.templates[0].dag.tasks).length);
                delete me.value.object.spec.templates[0].steps;
            } else {
                delete me.value.object.spec.templates[0].dag;
                delete me.value.object.spec.templates[0].steps;
                me.value.object.spec.templates[0].container = {
                    "name": "",
                    "image": "",
                    "command": [ "" ],
                    "args": [ "" ],
                }
            }

            this.$EventBus.$on(`${me.value.elementView.id}`, function (obj) {
                if(obj.action=="deleteStep" && obj.element && obj.element._type == "WorkflowStep") {
                    me.value.steps.splice(me.value.steps.indexOf(obj.element), 1);
                    me.value.object.spec.templates[0].steps.splice(obj.element.index, 1);
                }
                if(obj.action=="deleteDag" && obj.element && obj.element._type == "WorkflowDag") {
                    me.value.tasks.splice(me.value.tasks.indexOf(obj.element), 1);
                    me.value.object.spec.templates[0].dag.tasks.splice(obj.element.index, 1);
                }
                if(obj.action=="showProperty" && obj.element && obj.element._type.includes("Workflow")) {
                    me.selected = true;
                    me.showProperty();
                }
                if (obj.action == "closeProperty" && obj.element && obj.element._type.includes("Workflow")) {
                    me.selected = false;
                    me.closePanel();
                }

                if(obj.action=="updateDag" && obj.element && obj.element._type == "WorkflowDag") {
                    me.value.object.spec.templates[0].dag.tasks[obj.element.index] = obj.element.object;
                }
            });
        },
        watch: {
            name(appName){
                this.value.name = appName;
                this.menuList.forEach((cmd) => {
                    if(cmd.name.includes('argo get')) {
                        cmd.name = "argo get " + appName;
                    }
                    if(cmd.name.includes('argo logs')) {
                        cmd.name = "argo logs " + appName;
                    }
                })
            },
            'value.object': {
                deep: true,
                handler(val) {
                    var me = this;
                    if(me.value.workflowType == "steps") {
                        me.setSteps((me.value.object.spec.templates[0].steps).length);
                    } else if(me.value.workflowType == "dag") {
                        me.setTasks((me.value.object.spec.templates[0].dag.tasks).length);
                    }
                    me.refresh();
                }
            },
        },
        methods: {
            setSteps(idx) {
                var me = this;
                let key = "spec.templates[0].steps[" + idx + "][0]";
                let obj = {
                    [key]: {
                        "name": "",
                        "template": "",
                        "arguments": {
                            "parameters": []
                        }
                    }
                };
                me.value.advancedAttributePaths = obj;

                if(idx > (me.value.steps).length) {
                    var designer = this.getComponent('kubernetes-model-canvas');
                    if(idx == 1) {
                        me.stepComp.x = me.value.elementView.x-210;
                    } else {
                        me.stepComp.x = me.value.steps[(me.value.steps).length-1].elementView.x+100;
                    }
                    me.stepComp.y = me.value.elementView.y;
                    let el = designer.addElement(me.stepComp);
                    el.parentId = me.value.elementView.id;
                    el.parentElName = me.value.object.metadata.generateName;
                    el.index = (me.value.steps).length;
                    el.name = "step" + (el.index+1);
                    me.value.steps.push(el);
                }
                me.value.steps.forEach(step => {
                    step.object.name = me.value.object.spec.templates[0].steps[step.index][0].name;
                });
            },
            setTasks(idx) {
                var me = this;
                let key = "spec.templates[0].dag.tasks[" + idx + "]";
                let obj = {
                    [key]: {
                        "name": "Task"+((me.value.tasks).length+1),
                        "template": "",
                        "arguments": {
                            "parameters": []
                        }
                    }
                };
                me.value.advancedAttributePaths = obj;

                if(idx > (me.value.tasks).length) {
                    var designer = this.getComponent('kubernetes-model-canvas');
                    if(idx == 1) {
                        me.taskComp.x = me.value.elementView.x-210;
                    } else {
                        me.taskComp.x = me.value.tasks[(me.value.tasks).length-1].elementView.x+120;
                    }
                    me.taskComp.y = me.value.elementView.y;
                    let el = designer.addElement(me.taskComp);
                    el.parentId = me.value.elementView.id;
                    el.parentElName = me.value.object.metadata.generateName;
                    el.index = (me.value.tasks).length;
                    el.name = "task";
                    me.value.tasks.push(el);
                }
                me.value.tasks.forEach(task => {
                    task.object.name = me.value.object.spec.templates[0].dag.tasks[task.index].name;
                });
            }
        },
    }
</script>

<style>

</style>